import React, { Fragment } from 'react'
import moment from 'moment-timezone'
import {
  SurgicalScheduleModel,
  EquipamentsModel,
  AppointmentModel
} from 'domain/entities/surgical-schedule-model'
import { Procedure } from 'presentation/doctor/pages/Patient'
import DividerNew from 'presentation/shared/components/DividerNew'
import * as S from './styles'

type Props = {
  surgicalSchedule: SurgicalScheduleModel
}

enum AnesthetistType {
  CHOOSE_ANESTHESTIST = 'choose-anesthetist',
  SCALE = 'scale',
  LOCAL = 'local-anesthesia'
}

const SurgeryDetailsInfo = ({ surgicalSchedule }: Props) => {
  const filteredMainProcedure =
    surgicalSchedule?.surgical_order?.procedures.filter(
      (procedure: Procedure) => {
        return procedure.isMain === true
      }
    )

  const mainProcedure = () => {
    if (filteredMainProcedure?.length > 0) {
      return filteredMainProcedure[0]?.description
    } else {
      return ''
    }
  }

  const getAnesthetistType = (anesthetist: any) => {
    if (anesthetist.type === AnesthetistType.CHOOSE_ANESTHESTIST) {
      return {
        title: 'Anestesista de preferência:',
        data: anesthetist.name
      }
    }

    if (anesthetist.type === AnesthetistType.LOCAL) {
      return { title: 'Anestesia:', data: 'Local' }
    }

    if (anesthetist.type === AnesthetistType.SCALE) {
      return { title: 'Anestesia:', data: 'Escala' }
    }
  }

  return (
    <>
      <S.ScrollContainer>
        {surgicalSchedule.status === 'analyze-canceled' && (
          <S.CancelledContainer>
            <S.CancelledTitle>Motivo do cancelamento:</S.CancelledTitle>

            <S.CancelledText>
              {surgicalSchedule.reason_to_cancel_solicitation}
            </S.CancelledText>

            <S.CancelledText>
              Cancelado por {surgicalSchedule.cancel_solicitation_by_name} {''}
              em{' '}
              {moment(surgicalSchedule.cancel_solicitation_date).format(
                'DD/MM/YYYY [às] HH:mm[h]'
              )}
            </S.CancelledText>
          </S.CancelledContainer>
        )}
        <S.FlexContainer>
          <S.ContainerInfo>
            {surgicalSchedule.status === 'scheduled' && (
              <>
                <strong>Agendamento:</strong>
                {surgicalSchedule?.anesthetist?.type && (
                  <p>
                    {getAnesthetistType(surgicalSchedule?.anesthetist)?.title}
                    &nbsp;
                    <span>
                      {getAnesthetistType(surgicalSchedule?.anesthetist)?.data}{' '}
                    </span>
                  </p>
                )}
                <p>
                  Sala: &nbsp;
                  <span>
                    {surgicalSchedule?.surgical_order?.surgery_center_name}-
                    {
                      surgicalSchedule.appointments?.filter(
                        (appointment: AppointmentModel) => {
                          return appointment.status === 'scheduled'
                        }
                      )[0]?.room_id
                    }
                    {/* {surgicalSchedule?.surgical_order?.room_id} */}
                  </span>
                </p>
                <p>
                  Duração: &nbsp;
                  <span>
                    {
                      surgicalSchedule.appointments?.filter(
                        (appointment: AppointmentModel) => {
                          return appointment.status === 'scheduled'
                        }
                      )[0]?.time
                    }
                  </span>
                </p>
                <p>
                  Data e Horário da Cirurgia: &nbsp;
                  <span>
                    {moment(surgicalSchedule?.surgery_day)
                      // .subtract(3, 'hours')
                      .format('DD/MM/YYYY HH:mm')}
                  </span>
                </p>
              </>
            )}
          </S.ContainerInfo>

          {surgicalSchedule.status === 'scheduled' && surgicalSchedule.id && (
            <S.Separator />
          )}

          {surgicalSchedule.id && (
            <S.ContainerInfo>
              <strong>Solicitação:</strong>
              {surgicalSchedule?.anesthetist?.type && (
                <p>
                  {getAnesthetistType(surgicalSchedule?.anesthetist)?.title}
                  &nbsp;
                  <span>
                    {getAnesthetistType(surgicalSchedule?.anesthetist)?.data}{' '}
                  </span>
                </p>
              )}
              <p>
                Sala: &nbsp;
                <span>
                  {surgicalSchedule?.surgical_order?.surgery_center_name}-
                  {
                    surgicalSchedule.appointments?.filter(
                      (appointment: AppointmentModel) => {
                        return appointment.status === 'pre-scheduling'
                      }
                    )[0]?.room_id
                  }
                </span>
              </p>
              <p>
                Duração: &nbsp;
                <span>
                  {
                    surgicalSchedule.appointments?.filter(
                      (appointment: AppointmentModel) => {
                        return appointment.status === 'pre-scheduling'
                      }
                    )[0]?.time
                  }
                </span>
              </p>

              <p>Data e Horário da Cirurgia: &nbsp;</p>
              {surgicalSchedule?.appointments
                ?.filter((appointment: AppointmentModel) => {
                  return appointment.status === 'pre-scheduling'
                })
                ?.map((appointment: AppointmentModel, index: number) => {
                  return (
                    <Fragment key={index}>
                      <p>
                        <span>
                          Opção {index + 1} -{' '}
                          {moment
                            .utc(appointment?.start_date)
                            .format('DD/MM/YYYY HH:mm')}
                          {appointment?.is_preferential && ' (preferencial)'}
                        </span>
                      </p>
                    </Fragment>
                  )
                })}

              {surgicalSchedule.status === 'requested' && (
                <p>
                  <span>
                    {' '}
                    <strong className="orange">Atenção:</strong> Esta cirurgia
                    ainda não foi agendada, apenas solicitada.
                  </span>
                </p>
              )}
            </S.ContainerInfo>
          )}
        </S.FlexContainer>

        <S.ContainerInfo>
          {!!surgicalSchedule?.reason_to_scheduling_is_another_date && (
            <>
              <p className="black"> Motivo de escolher outra data/horário:</p>
              <span>
                {surgicalSchedule?.reason_to_scheduling_is_another_date}
              </span>
            </>
          )}

          {!!surgicalSchedule?.observation_to_scheduling_is_another_date && (
            <>
              <p className="black"> Observações:</p>
              <span>
                {surgicalSchedule?.observation_to_scheduling_is_another_date}
              </span>
            </>
          )}
        </S.ContainerInfo>

        <DividerNew />

        <S.ContainerInfo>
          <strong>Dados do paciente:</strong>
          <h1 className="schedule-name">{surgicalSchedule?.patient?.name}</h1>
          <p className="schedule-info">
            Data de Nascimento: &nbsp;
            <span>
              {moment
                .utc(surgicalSchedule?.patient?.birthday)
                .format('DD/MM/YYYY')}
            </span>
          </p>
          <p className="schedule-info">
            Convênio:&nbsp;
            <span>
              {surgicalSchedule?.surgical_order?.health_insurance.name}
            </span>
          </p>
        </S.ContainerInfo>

        <DividerNew />

        <S.FlexContainer style={{ justifyContent: 'space-between' }}>
          <S.ContainerInfo style={{ maxWidth: '400px' }}>
            <strong>Informações da cirurgia:</strong>

            <h1 className="schedule-name">{mainProcedure()}</h1>

            <p>
              Aviso cirúrgico: &nbsp;
              <span>{surgicalSchedule?.surgical_order?.id}</span>
            </p>

            <p>
              Especialidade: &nbsp;
              <span>{surgicalSchedule?.doctor?.specialty}</span>
            </p>

            <p>
              Cirurgião(ã) responsável: &nbsp;
              <span>{surgicalSchedule?.doctor?.name}</span>
            </p>

            <p>
              Precisa de banco de Sangue?: &nbsp;
              <span>
                {surgicalSchedule?.surgical_order?.blood_reserve
                  ? 'Sim'
                  : 'Não'}
              </span>
            </p>

            <p>
              Precisa de CTI? &nbsp;
              <span>
                {surgicalSchedule?.surgical_order?.cti ? 'Sim' : 'Não'}
              </span>
            </p>

            <p>
              Congelação: &nbsp;
              <span>
                {surgicalSchedule?.surgical_order?.freezing ? 'Sim' : 'Não'}
              </span>
            </p>

            <p>
              Técnica: &nbsp;
              <span>{surgicalSchedule?.surgical_order?.tecnic}</span>
            </p>

            <p>
              Observações gerais: &nbsp;
              <span>{surgicalSchedule?.general_observation}</span>
            </p>
          </S.ContainerInfo>

          <S.Separator />

          <S.ContainerInfo style={{ width: '400px' }}>
            <p>
              Precisa incluir equipamentos? &nbsp;
              <span>
                {surgicalSchedule?.equipaments?.length ? 'Sim' : 'Não'}
              </span>
            </p>

            {surgicalSchedule?.equipaments?.length > 0 ? (
              <S.Table>
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Equipamento</th>
                  </tr>
                </thead>
                <tbody>
                  {surgicalSchedule?.equipaments.map(
                    (equipment: EquipamentsModel) => {
                      return (
                        <tr key={equipment.code}>
                          <td>{equipment.code || 'Sem código'}</td>
                          <td className="description">{equipment?.name}</td>
                        </tr>
                      )
                    }
                  )}
                </tbody>
              </S.Table>
            ) : (
              <S.SoftText>Nenhum equipamento foi adicionado</S.SoftText>
            )}
          </S.ContainerInfo>
        </S.FlexContainer>
      </S.ScrollContainer>
    </>
  )
}

export default SurgeryDetailsInfo
